import { TTokenRefreshState } from './types';

export const DEFAULT_TOKEN_REFRESH_STATE: TTokenRefreshState = {
  isRefreshing: false,
  startedAt: null,
  tabId: null,
  heartbeatAt: null,
};
